export default __webpack_public_path__ + "static/media/rec3dvalley.2e254ab6.jpg";